// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: simplified Microsoft Outlook mark.

interface OutlookLogoProps {
	size?: number;
	style?: React.CSSProperties;
}

export function OutlookLogo({size = 16, style}: OutlookLogoProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 32 32"
			fill="none"
			aria-hidden="true"
			style={{flexShrink: 0, ...style}}
		>
			<rect x="9" y="4" width="20" height="24" rx="2" fill="#1066B5" />
			<rect x="9" y="4" width="20" height="12" rx="2" fill="#32A9E7" />
			<path d="M9 16h20v10a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V16Z" fill="#0F5CA8" opacity="0.35" />
			<rect x="2" y="8" width="16" height="16" rx="2" fill="#0F6CBD" />
			<ellipse cx="10" cy="16" rx="4.6" ry="5.4" stroke="white" strokeWidth="2.6" />
		</svg>
	);
}
